import classNames from 'classnames'
import CircleIcon from 'mdi-react/CircleIcon'
import React from 'react'

import { createStyles, ListItem, ListItemIcon, ListItemText, Theme } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

export function BulletPoint({ classes, className, item, children }: BulletPointProps) {
  return (
    <ListItem className={classNames(className, classes.listItem)}>
      <ListItemIcon className={classes.iconContainer}>
        <CircleIcon className={classes.icon} />
      </ListItemIcon>
      <ListItemText primary={item || children} />
    </ListItem>
  )
}

type BulletPointProps = WithStyles<typeof styles> & {
  className?: string
  item?: React.ReactNode
  children?: React.ReactNode
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    listItem: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
    },
    iconContainer: {
      minWidth: spacing(3),
    },
    icon: {
      marginTop: spacing(1.25),
      width: 8,
      height: 8,
    },
  })

export default withStyles(styles)(BulletPoint)
